<template>
    <div>
        <tuango-base-line-chart :provider="dataProviderAccepted" title="Accepted transactions" color="#2ecc71"></tuango-base-line-chart>
        <tuango-base-line-chart :provider="dataProviderRejected" title="Rejected Transactions" color="#e74c3c"></tuango-base-line-chart>
    </div>
</template>

<script>
  /* ============
   * User Metrics Component
   * ============
   *
   */
  import TuangoBaseLineChart from '@/app/components/metrics/BaseLineChart'
  import AcceptedTransactionsMetrics from '@/app/proxies/AcceptedTransactionsMetricsProxy'
  import RejectedTransactionsMetrics from '@/app/proxies/RejectedTransactionsMetricsProxy'

  export default {
    components: {
      TuangoBaseLineChart
    },
    data () {
      return {
        dataProvider: null
      }
    },
    created () {
      this.dataProviderAccepted = new AcceptedTransactionsMetrics()
      this.dataProviderRejected = new RejectedTransactionsMetrics()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Metrics/Transactions.vue